import { useUpcomingBirthdays, type UpcomingBirthday } from "@/hooks/use-birthdays";

function MiniAvatar({ user }: { user: UpcomingBirthday }) {
  const initials = user.full_name
    .split(" ")
    .map((n) => n[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();
  return user.avatar_url ? (
    <img
      src={user.avatar_url}
      alt={user.full_name}
      className="w-6 h-6 rounded-full object-cover ring-[1.5px] ring-[var(--sr-revemoerk)]"
    />
  ) : (
    <span className="w-6 h-6 rounded-full bg-white text-[var(--sr-revemoerk)] text-[10px] font-medium flex items-center justify-center ring-[1.5px] ring-[var(--sr-revemoerk)]">
      {initials}
    </span>
  );
}

function formatWhen(daysUntil: number): string {
  if (daysUntil === 0) return "i dag";
  if (daysUntil === 1) return "i morgen";
  return `om ${daysUntil} dager`;
}

export default function BirthdayBanner() {
  const { data: upcoming } = useUpcomingBirthdays(7);

  if (!upcoming || upcoming.length === 0) return null;

  const today = upcoming.filter((u) => u.daysUntil === 0);
  const rest = upcoming.filter((u) => u.daysUntil > 0);

  return (
    <div className="border-[1.5px] border-[var(--sr-revemoerk)] bg-[color-mix(in_oklab,var(--sr-reverosa)_40%,white)] p-4 flex items-start gap-3 animate-fade-in">
      <span className="text-[22px] leading-none shrink-0" aria-hidden>
        🎂
      </span>
      <div className="flex-1 space-y-2 text-[var(--sr-revemoerk)]">
        {today.length > 0 && (
          <div className="flex flex-wrap items-center gap-2">
            <p className="text-sm font-medium">
              Gratulerer med dagen, {today.map((u) => u.full_name).join(", ")}!
            </p>
            <div className="flex -space-x-1.5">
              {today.map((u) => (
                <MiniAvatar key={u.id} user={u} />
              ))}
            </div>
          </div>
        )}
        {rest.length > 0 && (
          <div className="flex flex-wrap items-center gap-2 text-sm">
            <span className="opacity-80">Bursdag denne uken:</span>
            {rest.map((u) => (
              <span key={u.id} className="inline-flex items-center gap-1.5">
                <MiniAvatar user={u} />
                <span className="font-medium">{u.full_name}</span>
                <span className="opacity-70">({formatWhen(u.daysUntil)})</span>
              </span>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
